module.exports = __webpack_public_path__ + "img/image_2_tablet.7cc96ce.jpg";